var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyContentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 106,
    viewBox: "0 0 136 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.222656,
    y: 0.5,
    width: 134.815,
    height: 105,
    rx: 7.52507,
    fill: "#1F477D",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.07422,
    y: 6.5,
    width: 36,
    height: 5,
    rx: 2.5,
    fill: "#1F477D",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 120,
    height: 83,
    rx: 4,
    fill: "#1F477D",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 56.5L71 60.5M63 60.5L67 56.5L63 60.5ZM67 56.5L71 52.5L67 56.5ZM67 56.5L63 52.5L67 56.5Z",
    stroke: "#1F477D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyContentIcon);
export default __webpack_public_path__ + "static/media/EmptyContentIcon.b606717ed95c03de6127e0a54a920f0f.svg";
export { ForwardRef as ReactComponent };